export default __webpack_public_path__ + "static/media/pear.2f368a37.webp";